import UpdateBanksModal from './UpdateBanksModal';

export default UpdateBanksModal;
